var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Text, TextMicro, TextSmall } from "../typography";
import PillIcon from "./icon";
import { getPillColor } from "./mixins/colors";
import { PillContainer } from "./styled";
var TextComponents = {
    default: TextMicro,
    large: Text,
    normal: Text,
    small: TextSmall,
};
var Pill = forwardRef(function (_a, ref) {
    var children = _a.children, background = _a.background, color = _a.color, _b = _a["data-testid"], testId = _b === void 0 ? "pill" : _b, flavour = _a.flavour, hollow = _a.hollow, icon = _a.icon, iconSize = _a.iconSize, normal = _a.normal, reverse = _a.reverse, size = _a.size, textSize = _a.textSize, tiny = _a.tiny, rest = __rest(_a, ["children", "background", "color", "data-testid", "flavour", "hollow", "icon", "iconSize", "normal", "reverse", "size", "textSize", "tiny"]);
    var iconProps = { color: color, flavour: flavour, hollow: hollow, icon: icon, size: iconSize };
    if (tiny)
        return (React.createElement(PillContainer, __assign({ background: background, "data-testid": "".concat(testId, "-tiny"), flavour: flavour, hollow: hollow, ref: ref, tiny: true }, rest)));
    var Text = textSize
        ? TextComponents[textSize]
        : TextComponents[size] || TextComponents.default;
    return (React.createElement(PillContainer, __assign({ background: background, "data-testid": testId, flavour: flavour, gap: 1, hollow: hollow, ref: ref, size: size }, rest),
        !reverse && React.createElement(PillIcon, __assign({ "data-testid": "".concat(testId, "-icon-left") }, iconProps)),
        children && (React.createElement(Text, { color: color || (hollow ? getPillColor("color", flavour) : "bright"), "data-testid": "".concat(testId, "-text"), strong: !normal, whiteSpace: "nowrap" }, children)),
        reverse && React.createElement(PillIcon, __assign({ "data-testid": "".concat(testId, "-icon-right") }, iconProps))));
});
export default Pill;
